import { render, staticRenderFns } from "./opportunities.vue?vue&type=template&id=1c8f3f96&scoped=true&"
import script from "./opportunities.vue?vue&type=script&lang=js&"
export * from "./opportunities.vue?vue&type=script&lang=js&"
import style0 from "./opportunities.vue?vue&type=style&index=0&id=1c8f3f96&scoped=true&lang=css&"
import style1 from "./opportunities.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8f3f96",
  null
  
)

export default component.exports